import { Link } from "react-router-dom";
import { Award } from "lucide-react";

interface AuthorBylineProps {
  className?: string;
}

const AuthorByline = ({ className = "" }: AuthorBylineProps) => (
  <div
    className={`mx-auto flex max-w-3xl items-start gap-3 rounded-xl border border-border bg-card/60 p-4 text-left ${className}`}
  >
    <Award className="mt-1 h-5 w-5 shrink-0 text-accent" aria-hidden="true" />
    <p className="font-sans text-sm leading-relaxed text-muted-foreground">
      <Link to="/about" className="font-heading font-semibold text-foreground hover:text-accent">
        Mahirah, Founder - MVIBE
      </Link>
      . ICF-aligned Executive Coach with 15+ years in IT HR leadership. Credentialed in NLP,
      ART Therapy, Graphology, POSH, NABET Soft Skills and City &amp; Guilds.
    </p>
  </div>
);

export default AuthorByline;
